interface LocationMapProps {
  lat: number;
  lng: number;
  /** Larger = tighter view. Maps to the embed bounding box. */
  zoom?: number;
  className?: string;
}

// OpenStreetMap embed — privacy-friendly (no Google third-party tracking fires
// on load, which matters for a public body under RGPD). Directions links that
// open Google Maps are fine elsewhere because those are user-initiated.
export default function LocationMap({ lat, lng, zoom = 16, className }: LocationMapProps) {
  // Bounding box around the point; higher zoom → smaller delta (tighter view).
  const delta = 0.6 / 2 ** (zoom - 12);
  const bbox = `${lng - delta},${lat - delta / 2},${lng + delta},${lat + delta / 2}`;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(
    bbox,
  )}&layer=mapnik&marker=${lat},${lng}`;

  return (
    <iframe
      src={src}
      title="Localização no mapa"
      className={className}
      style={{ border: 0, width: '100%', height: '100%' }}
      loading="lazy"
      referrerPolicy="no-referrer"
    />
  );
}
